/**
 * 参数：[socketOpen|socketClose|socketMessage|socketError] = func，[socket连接成功时触发|连接关闭|发送消息|连接错误]
 * timeout：连接超时时间
 * 详细介绍网址： https://www.cnblogs.com/houjl/p/10812519.html
 * @type {module.webSocket}
 */
class webSocket {
  constructor(options = {}) {
    // console.log('options', options);
    this.options = options || {};
    this.socket = null;
    this.taskRemindInterval = null; // 错误时，重连
    this.heartBeatInterval = null; // 心跳定时
    this.closeSocketTime = null;
  }

  onCreate(mobileNo) {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    const { url } = this.options;
    const socketUrl = mobileNo ? url + mobileNo : url;
    console.log("开始连接。。socketUrl", socketUrl);
    // 检测当前浏览器是什么浏览器来决定用什么socket
    if ("WebSocket" in window) {
      console.log("WebSocket");
      this.socket = new WebSocket(socketUrl);
    } else if ("MozWebSocket" in window) {
      console.log("MozWebSocket");
      this.socket = new MozWebSocket(socketUrl);
    } else {
      console.log("SockJS");
      this.socket = new SockJS(socketUrl);
    }
    this.socket.onopen = () => this.onopen();
    this.socket.onclose = data => this.onclose(data);
    this.socket.onmessage = data => this.onmessage(data);
    this.socket.onerror = data => this.onerror(data);
  }

  // 连接成功触发
  onopen() {
    const { onOpen } = this.options;
    onOpen && onOpen();
    this.closeSocketTime && clearTimeout(this.closeSocketTime);
    this.heartBeatInterval && clearInterval(this.heartBeatInterval);
    this.heartBeatInterval = setInterval(() => {
      if (this.socket && this.socket.readyState === 1) {
        this.socket.send('{msgType:"0"}');
      }
    }, 5000);
  }

  onclose() {
    console.log("sockete进入onclose方法，断开连接");
    this.socket = null;
    let { onClose } = this.options;
    this.heartBeatInterval && clearInterval(this.heartBeatInterval);
    this.closeSocketTime && clearTimeout(this.closeSocketTime);
    onClose && onClose();
    this.onCreate();
  }

  // 后端向前端推得数据
  onmessage(data) {
    // 打印出后端推得数据
    console.log("接收推送消息：", data);

    const { onMessage } = this.options;
    const { data: dataString } = data;
    try {
      const dataObject = JSON.parse(dataString);
      console.log("websocket 数据解析", dataObject);
      const { msgType } = dataObject;

      if (msgType === 0 || msgType === "0") {
        this.closeSocketTime && clearTimeout(this.closeSocketTime);
        this.closeSocketTime = setTimeout(() => {
          console.log("已超过1分钟未收到信息");
          //60秒后没收到信息的话断开socket重连
          this.closeSocket();
        }, 60000);
      }
      onMessage && onMessage(dataObject);
    } catch (err) {
      onMessage && onMessage(dataString);
    }
  }

  onerror(data) {
    let { onError } = this.options;
    console.log("socket出现错误", data);
    this.socket = null;
    onError && onError(data);
  }

  sendMessage = (data, failedCallback) => {
    if (this.socket) {
      this.socket.send(data);
    }
  };

  // 关闭连接
  closeSocket = () => {
    try {
      this.socket.close();
      this.socket = null;
      this.closeSocketTime && clearTimeout(this.closeSocketTime);
      this.heartBeatInterval && clearInterval(this.heartBeatInterval);
    } catch (err) {
      console.log(`closeSocket err = ${err}`);
    }
  };
}

export { webSocket };



// WEBPACK FOOTER //
// ./src/websocket.js